import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SharedModule } from '../../../../shared/shared.module';
import _ from 'lodash';
import { PaginatorModule } from 'primeng/paginator';
import { SalesPersonService } from '../../../../services/sales-person.service';
import { salesPerson, salesPersonGridResponse } from '../../../../model/masters.model';
import { gridPageRequest, gridPagination } from '../../../../model/common/common.model';
import { LoaderComponent } from '../../../loader/loader.component';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-sales-person-list',
  standalone: true,
  imports: [SharedModule,CommonModule,PaginatorModule,LoaderComponent],
  templateUrl: './sales-person-list.component.html',
  styleUrl: './sales-person-list.component.scss'
})
export class SalesPersonListComponent {
  @ViewChild('dt1') dt1: Table | undefined;
  selectedSalesperson: salesPerson[] = [];
  searchKey : any;
  first = 0;

    rows = 10;
  paginator: boolean | undefined;

  constructor(private route: Router, private salespersonservice: SalesPersonService, private confirmationService:ConfirmationService, private messageService: MessageService) {  }
  salespersons: salesPerson[] = [];
  start: number = 0;
  rowsPerPage: number = 5;
  gridPagination: gridPagination = {
    first: 0,
    last: 0,
    totalRecords: 0
  }

  result: salesPersonGridResponse = {
    salespersons: [],
    totalRecords: 0
  }

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 50,
    id: 0
  }

  loader: boolean = false;

  ngOnInit(): void {
    this.getSalesperson(this.pageRequest);
    document.title = 'List Salesperson';
    this.searchEffect();
  }

   getSalesperson(query: gridPageRequest): void {
    // this.loader = true;
    this.salespersonservice.getAllSalesperson(query).subscribe({
      next: (data: any) => {
        console.log(data);
        if (data && data.salespersons) {
          this.result = {
            ...data,
            salespersons: data.salespersons
            // salespersons: data.salespersons.map((salesperson: any) => {
            //   return {
            //     ...salesperson,
            //     // salespersonImage: salesperson.salespersonImage
            //     //   ? `data:image/jpeg;base64,${salesperson.salespersonImage}`
            //     //   : './assets/no-image.jpg'
            //   };
            // })
          };
          // this.salespersons = this.result.salespersons; // Update salespersons array
          // this.loader = false;
          this.salespersons=[];
        }

      },
      error: error => {
        console.error(error);
        // this.loader = false;
      }
    });
  }



  CreateSalesPerson() {
    this.route.navigate(['/home/createsalesPerson']);
  }

  editSalesPerson(data?:any) {
    if(data){
      this.route.navigate(['/home/createsalesPerson'], { queryParams: { 'salespersonId': data }, skipLocationChange: true },);
    }else{
      this.route.navigate(['/home/createsalesPerson'], { queryParams: { 'salespersonId': this.selectedSalesperson[0].salespersonId }, skipLocationChange: true },);
    }
  }

  deleteSalesPerson() {
    this.confirmationService.confirm({
      header: 'Are you sure?',
      message: 'Please confirm to proceed.',
      accept: () => {
          this.loader = true;

          var salespersonId = _.map(this.selectedSalesperson, 'salespersonId');

          this.salespersonservice.deleteSalesperson(salespersonId).subscribe({
            next: (data: any) => {
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Salesperson deleted successfully.' });
                this.loader = false;
                this.selectedSalesperson = [];
                this.getSalesperson(this.pageRequest);
            },
            error: error => {
              this.loader = false;
              console.log(error);
            }
          })
      },
      reject: () => {
      }
  });
  }

 loadsalespersons(event: any): void {
    if (this.searchKey) return;

    this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + 5;
    this.getSalesperson(this.pageRequest);
  }

searchSales(): void {
    const filterValue = this.searchKey?.trim();
  
    if (!filterValue) {
      return; 
    }
  
    this.salespersonservice.autoSearchSalesPerson(filterValue).subscribe(


      (data: any) => {
        if (data) {
          this.result.salespersons = data.map((salespersons: any) => {
            return {
              ...salespersons,
              salespersonImage: salespersons.salespersonImage ? `data:image/jpeg;base64,${salespersons.salespersonImage}` : './assets/no-image.jpg'
            };
          });
  
          if (this.dt1) {
            this.dt1.first = 0; 
          }
        } else {
        }

      },
      (error: any) => {
        console.log(error);


      }
    );
  }
  refreshData(): void {
    if (this.dt1) {
      this.dt1.first = 0; 
      this.dt1.clear();
    }
    this.searchKey = ''; 
    this.pageRequest.pageIndex = 0;
    this.pageRequest.pageSize = 50; 
    this.getSalesperson(this.pageRequest); 
  }

  placeholder: string = 'Search By ';
  private messages: string[] = ['Salesperson Code',	'Salesperson Name',	'Mobile',	'Email',	'State']; 
  private messageIndex = 0;
  private charIndex = 0;


  searchEffect() {
    const base = 'Search By ';
    const typeNextChar = () => {
      if (this.charIndex <= this.messages[this.messageIndex].length) {
        this.placeholder = base + this.messages[this.messageIndex].substring(0, this.charIndex);
        this.charIndex++;
        setTimeout(typeNextChar, 150);
      } else {
        setTimeout(() => {
          this.messageIndex = (this.messageIndex + 1) % this.messages.length;
          this.charIndex = 0;
          typeNextChar();
        }, 1000);
      }
    };
    typeNextChar();
  }
  
}
